namespace HA.Core.Entity {

    export class User extends Entity {
        /**
         *
         * @param data
         */
        public update(data: Map<any, any>) {
            this.updateData(data);
        }

        /**
         *
         * @returns {Map<String, any>}
         */
        public getProfileData() {
            return this.getData();
        }
    }
}
